// Mock data for RepresenX

export const mockPresences = [
  {
    id: '1',
    name: 'My Digital Presence',
    status: 'active',
    createdAt: '2025-01-15',
    interactions: 47,
    memoryNodes: 23,
    lastActive: '2 hours ago'
  }
];

export const mockConversations = [
  {
    id: '1',
    question: 'How would I respond to someone seeking advice about resilience?',
    response: "You'd remind them that strength grows in uncertainty — and that every setback refines direction.",
    timestamp: '2025-01-20 14:30'
  },
  {
    id: '2',
    question: 'What would I say about taking risks?',
    response: 'You believe calculated risks are the bridge between comfort and growth. Fear is data, not a stop sign.',
    timestamp: '2025-01-20 12:15'
  },
  {
    id: '3',
    question: 'How do I typically give feedback?',
    response: 'You lead with empathy, then clarity. You acknowledge effort before addressing gaps.',
    timestamp: '2025-01-19 16:45'
  }
];

export const mockActivityFeed = [
  { id: '1', type: 'interaction', description: 'Presence responded to query about values', time: '2 hours ago' },
  { id: '2', type: 'update', description: 'Memory node added: Career milestone', time: '5 hours ago' },
  { id: '3', type: 'interaction', description: 'Style tuning adjusted: More direct tone', time: '1 day ago' },
  { id: '4', type: 'interaction', description: 'Presence activated in conversation mode', time: '2 days ago' },
  { id: '5', type: 'update', description: 'Value mapping refined', time: '3 days ago' }
];

export const mockMemoryGraph = {
  nodes: [
    { id: '1', label: 'Early Career', connections: 3, importance: 'high' },
    { id: '2', label: 'Family Values', connections: 5, importance: 'high' },
    { id: '3', label: 'Travel Experiences', connections: 2, importance: 'medium' },
    { id: '4', label: 'Professional Growth', connections: 4, importance: 'high' },
    { id: '5', label: 'Personal Philosophy', connections: 6, importance: 'high' }
  ]
};

export const mockMetrics = {
  totalInteractions: 47,
  memoryNodes: 23,
  activeConnections: 15,
  accuracyScore: 94
};

export const mockUserProfile = {
  name: 'Alex Morgan',
  email: 'alex@example.com',
  presenceName: 'My Digital Presence',
  plan: 'Enhanced Persona',
  createdAt: '2025-01-15'
};
